export const translations = {
  en: {
    portal: "FO Portal",
    login: "Login",
    name: "Name",
    password: "Password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    submit: "Login",
    submitting: "Logging in…",
    required: "Name and password are required",
    invalid: "Invalid name or password",
    failed: "Login failed",
    welcome: "Welcome",
    logout: "Logout",
    productManagement: "Product Management",
    submittedList: "Submitted Product List",
    addProduct: "Add New Product",
    chooseWatch: "Watch",
    chooseOther: "Other Product",
    addWatch: "Add Watch",
    editWatch: "Edit Watch",
    watchName: "Watch Name",
    watchBrandRequired: "Watch brand is required",
    specification: "Specification",
    spec: {
      brand: "Brand",
      size: "Size",
      color: "Color",
      family: "Family",
      dial: "Dial",
      modelNo: "Model No.",
      movement: "Movement",
      caliber: "Caliber",
      powerReserve: "Power Reserve",
      precision: "Precision",
      secondHand: "Second Hand",
      caseMaterial: "Case Material",
      caseColor: "Case Color",
      bezelMaterial: "Bezel Material",
      bezelColor: "Bezel Color",
      crystal: "Crystal",
      thickness: "Thickness",
      braceletMaterial: "Bracelet Material",
      braceletType: "Bracelet Type",
      braceletColor: "Bracelet Color",
      braceletSize: "Bracelet Size",
      claspMaterial: "Clasp Material",
      claspType: "Clasp Type",
      claspColor: "Clasp Color",
      dialColor: "Dial Color",
      indices: "Indices",
      hourMarkersMaterial: "Hour Markers Material",
      hourMarkersType: "Hour Markers Type",
      handsMaterial: "Hands Material",
      handsType: "Hands Type",
      functions: "Functions",
      waterResistance: "Water Resistance",
    },
    searchPlaceholder: "Search by name…",
    brand: "Brand",
    all: "All",
    clear: "Clear",
    colIndex: "#",
    colImage: "Image",
    colName: "Product Name",
    colBrand: "Brand",
    colPrice: "Price",
    colDate: "Date Added",
    colActions: "Actions",
    edit: "Edit",
    delete: "Delete",
    showing: "Showing",
    of: "of",
    empty: "No products yet.",
    loadFailed: "Could not load products.",
    deleteConfirm: "Delete this product?",
    deleteFailed: "Could not delete this product.",
    saveFailed: "Could not save this product.",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving…",
    create: "Create",
    creating: "Creating…",
    editProduct: "Edit Product",
    enProductName: "Product Name",
    cnName: "Chinese Product Name",
    category: "Category",
    subcategory: "Subcategory",
    subsubcategory: "Sub-subcategory",
    genderType: "Gender Type",
    genderMen: "Men",
    genderWomen: "Women",
    genderKids: "Kids",
    genderUnisex: "Unisex",
    genderBoys: "Boys",
    genderGirls: "Girls",
    costRmb: "RMB",
    supplier: "Supplier",
    enDescription: "English Description",
    cnDescription: "Chinese Description",
    remarks: "Remarks",
    selectBrand: "Select brand",
    noMatchingBrand: "No matching brand",
    selectCategory: "Select category",
    selectSubcategory: "Select subcategory",
    selectSubsubcategory: "Select sub-subcategory",
    selectCategoryFirst: "Select category first",
    selectSubcategoryFirst: "Select subcategory first",
    noSubcategories: "No subcategories",
    noSubsubcategories: "No sub-subcategories",
    formRequired: "Brand, category, and gender type are required",
    nameRequired: "Enter an English product name or a Chinese product name",
    toastCreated: "Product created",
    toastUpdated: "Product updated",
    toastDeleted: "Product deleted",
    mediaUploadFailed: "Product saved, but photos/videos failed to upload. Open the product and try again.",
    mediaRolesFailed: "Product saved and media uploaded, but primary/secondary image could not be saved. Open the product and try again.",
    media: "Photos / Videos",
    mediaHint: "Preview appears as soon as a file is selected.",
    mediaDrop: "Drag & drop or click to upload photos/videos",
    mediaRoleHint: "Prim = shop card image. Sec = hover image. They must be different photos.",
    mediaPrimaryOnlyHint: "Prim = shop card image. If unset, the first photo is used.",
    mediaPrimary: "Prim",
    mediaSecondary: "Sec",
    colStatus: "Status",
    statusCreated: "Submitted",
    statusReview: "In review",
    statusRejected: "Rejected",
    rejectedBanner: "This product was rejected. Please review the remarks, update it, and save again.",
    reviewBanner: "Resubmitted for review.",
    lastRejectReason: "Last reject reason",
    mediaRemoveConfirm: "Remove this photo/video?",
    last30Days: "Last 30 Days",
    created: "Created",
    approved: "Approved",
    rejected: "Rejected",
    calendar: "Calendar",
    calendarPrev: "Prev",
    calendarNext: "Next",
    weekdaysEn: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    weekdaysCn: ["一", "二", "三", "四", "五", "六", "日"],
  },
  cn: {
    portal: "FO 门户",
    login: "登录",
    name: "名称",
    password: "密码",
    showPassword: "显示密码",
    hidePassword: "隐藏密码",
    submit: "登录",
    submitting: "登录中…",
    required: "请输入名称和密码",
    invalid: "名称或密码不正确",
    failed: "登录失败",
    welcome: "欢迎",
    logout: "退出",
    productManagement: "产品管理",
    submittedList: "已提交的产品列表",
    addProduct: "添加新产品",
    chooseWatch: "手表",
    chooseOther: "其他产品",
    addWatch: "添加手表",
    editWatch: "编辑手表",
    watchName: "手表名称",
    watchBrandRequired: "请选择手表品牌",
    specification: "规格",
    spec: {
      brand: "品牌",
      size: "尺寸",
      color: "颜色",
      family: "系列",
      dial: "表盘",
      modelNo: "型号",
      movement: "机芯",
      caliber: "机芯型号",
      powerReserve: "动力储备",
      precision: "精度",
      secondHand: "秒针",
      caseMaterial: "表壳材质",
      caseColor: "表壳颜色",
      bezelMaterial: "表圈材质",
      bezelColor: "表圈颜色",
      crystal: "镜面",
      thickness: "厚度",
      braceletMaterial: "表带材质",
      braceletType: "表带类型",
      braceletColor: "表带颜色",
      braceletSize: "表带尺寸",
      claspMaterial: "表扣材质",
      claspType: "表扣类型",
      claspColor: "表扣颜色",
      dialColor: "表盘颜色",
      indices: "时标",
      hourMarkersMaterial: "时标材质",
      hourMarkersType: "时标类型",
      handsMaterial: "指针材质",
      handsType: "指针类型",
      functions: "功能",
      waterResistance: "防水",
    },
    searchPlaceholder: "搜索名称…",
    brand: "品牌",
    all: "全部",
    clear: "清除",
    colIndex: "#",
    colImage: "图片",
    colName: "产品名称",
    colBrand: "品牌",
    colPrice: "价格",
    colDate: "添加日期",
    colActions: "操作",
    edit: "编辑",
    delete: "删除",
    showing: "显示",
    of: "共",
    empty: "暂无产品。",
    loadFailed: "无法加载产品。",
    deleteConfirm: "确定删除此产品？",
    deleteFailed: "无法删除此产品。",
    saveFailed: "无法保存此产品。",
    cancel: "取消",
    save: "保存",
    saving: "保存中…",
    create: "创建",
    creating: "创建中…",
    editProduct: "编辑产品",
    enProductName: "英文产品名称",
    cnName: "中文产品名称",
    category: "分类",
    subcategory: "子分类",
    subsubcategory: "次子分类",
    genderType: "适用人群",
    genderMen: "男士",
    genderWomen: "女士",
    genderKids: "男女小孩通用",
    genderUnisex: "男女大人通用",
    genderBoys: "男孩",
    genderGirls: "女孩",
    costRmb: "RMB",
    supplier: "供应商",
    enDescription: "英文描述",
    cnDescription: "中文描述",
    remarks: "备注",
    selectBrand: "选择品牌",
    noMatchingBrand: "没有匹配的品牌",
    selectCategory: "选择分类",
    selectSubcategory: "选择子分类",
    selectSubsubcategory: "选择次子分类",
    selectCategoryFirst: "请先选择分类",
    selectSubcategoryFirst: "请先选择子分类",
    noSubcategories: "无子分类",
    noSubsubcategories: "无次子分类",
    formRequired: "请填写品牌、分类与适用人群",
    nameRequired: "请填写英文产品名称或中文产品名称",
    toastCreated: "产品已创建",
    toastUpdated: "产品已更新",
    toastDeleted: "产品已删除",
    mediaUploadFailed: "产品已保存，但照片/视频上传失败。请打开该产品后重试。",
    mediaRolesFailed: "产品与媒体已保存，但主图/副图未能保存。请打开该产品后重试。",
    media: "照片 / 视频",
    mediaHint: "选取文件后会立即显示缩略图。",
    mediaDrop: "拖放或点击以上传照片/视频",
    mediaRoleHint: "主图 = 商店卡片图。副图 = 悬停图。两张图必须不同。",
    mediaPrimaryOnlyHint: "主图 = 商店卡片图。未设置时使用第一张照片。",
    mediaPrimary: "主图",
    mediaSecondary: "副图",
    colStatus: "状态",
    statusCreated: "已提交",
    statusReview: "审核中",
    statusRejected: "已拒绝",
    rejectedBanner: "此产品已被拒绝。请查看原因、修改后再保存。",
    reviewBanner: "已重新提交审核。",
    lastRejectReason: "上次拒绝原因",
    mediaRemoveConfirm: "移除此照片/视频？",
    last30Days: "近30天",
    created: "已创建",
    approved: "已通过",
    rejected: "已拒绝",
    calendar: "日历",
    calendarPrev: "上一月",
    calendarNext: "下一月",
    weekdaysEn: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    weekdaysCn: ["一", "二", "三", "四", "五", "六", "日"],
  },
};

export function isPortalLang(value) {
  return value === "cn" || value === "en";
}
